export function formatToLocalDate(dateInput: string | number | Date, format: string = 'MMM dd, yyyy'): string | null {
  try {
    let date = typeof dateInput === 'number' && dateInput.toString().length === 10
      ? new Date(dateInput * 1000)
      : new Date(dateInput);

    if (isNaN(date.getTime())) {
      return null;
    }

    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };

    return new Intl.DateTimeFormat("en-US", options)
      .formatToParts(date)
      .reduce((formatted, part) => {
        switch (part.type) {
          case "weekday":
            return formatted.replace(/ddd/g, part.value);
          case "year":
            return formatted.replace(/yyyy/g, part.value);
          case "month":
            return formatted.replace(/MMM/g, part.value.slice(0, 3));
          case "day":
            return formatted.replace(/dd/g, part.value);
          case "hour":
            return formatted.replace(/hh/g, part.value);
          case "minute":
            return formatted.replace(/mm/g, part.value);
          case "second":
            return formatted.replace(/ss/g, part.value);
          default:
            return formatted;
        }
      }, format);
  } catch (error) {
    return null;
  }
}
